import { Grid, Typography } from "@material-ui/core";
import { getDatabase, onValue, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import Singlesettingitem from "../Setting/SingleSettingItem";

const Setting = () => {
  const [setting, setSetting] = useState({});
  useEffect(() => {
    const db = getDatabase();
    const settingRef = ref(db, "Settings/");
    onValue(settingRef, (snapshot) => {
      const data = snapshot.val();
      setSetting(data);
    });
  }, []);

  const options = [
    {
      name: "Refer User Bonus",
      value: setting?.referBonus,
      suffix: "BDT",
      property: "referBonus",
      inputType: "number",
    },
    {
      name: "Welcome Bonus",
      value: setting?.welcomeBonus,
      suffix: "BDT",
      property: "welcomeBonus",
      inputType: "number",
    },
    {
      name: "Click Bonus",
      value: setting?.clickBonus,
      suffix: "BDT",
      property: "clickBonus",
      inputType: "number",
    },
    {
      name: "VPN (on or off)",
      value: setting?.vpn,
      suffix: "BDT",
      property: "vpn",
      inputType: "text",
    },
    {
      name: "Upgrade Priority (high or low)",
      value: setting?.upgradePriority,
      suffix: "",
      property: "upgradePriority",
      inputType: "text",
    },
    {
      name: "Updated Version Number",
      value: setting?.upgradeVersion,
      suffix: "",
      property: "upgradeVersion",
      inputType: "number",
    },
    {
      name: "Pivacy Policy",
      value: setting?.privacyPolicy,
      suffix: "",
      property: "privacyPolicy",
      inputType: "text",
    },
    {
      name: "Contact Email",
      value: setting?.contactEmail,
      suffix: "",
      property: "contactEmail",
      inputType: "text",
    },
  ];

  return (
    <>
      <Typography variant="h3">Settings</Typography>
      <br />
      <Grid container spacing={5}>
        {options?.map((option) => (
          <Grid item xs={12} sm={6} md={6}>
            <Singlesettingitem option={option} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Setting;
